/* 公共方法 */
import Vue from 'vue';

Vue.prototype.resize = (width = 320) => {
  // const _width = window.screen.width;
  // const _width = window.innerWidth;
  const _width = document.documentElement.clientWidth;
  console.log('屏幕宽度: ' + _width);
  let ratio = _width / width;
  ratio = ratio > 2 ? 2 : ratio;
  document.getElementsByTagName('html')[0].style.fontSize = 16 * ratio + 'px';
};

/* 特殊字符转化 */
Vue.prototype.wordChange = (words) => {
  const oldWords = [...words];
  let newWords = '';
  oldWords.forEach((value) => {
    const spaceWord = /^[▪•●·.。`,，？?]+$/;
    const flags = spaceWord.test(value);
    if (flags) {
      value = '·';
    }
    newWords += value;
  });
  return newWords;
};

Vue.prototype.debugConsole = () => {
  ;(function () {
    const src = '//cdn.bootcss.com/eruda/1.4.2/eruda.min.js';
    if (!/debug=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
    document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
    document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
  })();
};


/* 反转义 */
Vue.prototype.htmlDecodeString = function (text) {
  let temp = document.createElement('div');
  temp.innerHTML = text;
  let output = temp.innerText || temp.textContent;
  temp = null;
  return output;
};

/* 转义 */
Vue.prototype.htmlEncode = function (html) {
  let temp = document.createElement ('div');
  (temp.textContent != null) ? (temp.textContent = html) : (temp.innerText = html);
  let output = temp.innerHTML;
  temp = null;
  return output;
};

/* 获取链接里的参数 */
Vue.prototype.getQueryString = function (variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0;i < vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){
      return pair[1];
    }
  }
  return false;
};

/* 排序 按照A数组的顺序重新排列B数组, A B 两数组的index相同 */
Vue.prototype.sortAB = function (a, b) {
  let c = [];
  for (let i in a) {
    for (let j in b) {
      if (a[i].index === b[j].index) {
        c.push(b[j]);
        continue;
      }
    }
  }
  return c;
};
// 判断数组里是否含有某个字段
Vue.prototype.arrayInData = function (arr, key, item) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === item) {
      return true;
    }
  }
  return false;
};
// 判断数组里是否含有某个元素
Vue.prototype.isInArray = function (arr, key) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === key) {
      return true;
    }
  }
  return false;
};
// 去掉数组里的空字段
Vue.prototype.arrayRemoveNull = function (arr) {
  for (let i = 0; i < arr.length; i++) {
    // alert(arr[i]);
    if (arr[i] === null || arr[i] === '' || arr[i] === undefined) {
      arr.splice(i,1);
      i = i-1;
    }
  }
  return arr;
};
Vue.prototype.isUndefine = function (key, value) {
  if (key !== undefined) {
    return key;
  } else {
    return value;
  }
};

//设置cookie
Vue.prototype.setCookie = function (cname, cvalue, domain, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${cname}=${cvalue};domain=${domain}; path=/;${expires}`;
};
// 获取cookie
Vue.prototype.getCookie = function (cname){
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

Vue.prototype.isIOS = function () {
  const isIphone = navigator.userAgent.includes('iPhone');
  const isIpad = navigator.userAgent.includes('iPad');
  return isIphone || isIpad
}
// 校验非法字符
Vue.prototype.checkScript = function (text) {
  var flag = false;
  var scriptWord = "<|>|script|alert|{|}|#|$|'|\"|:|;|&|*|@|@|%|^|?";
  var words = scriptWord.split('|');
  for (var i = 0; i < words.length; i += 1) {
    if (text.indexOf(words[i]) !== -1) {
      flag = true;
      break;
    }
  }
  return flag;
}
Vue.prototype.idCheck = function (idcard) {
  var area = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江', 31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北', 43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏', 61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外' }
  var Y, JYM;
  var S, M;
  var idcard_array = idcard.split('');
  //地区检验
  if (area[parseInt(idcard.substr(0, 2))] === null) {
    return false;
  }
  //身份号码位数及格式检验
  switch (idcard.length) {
    case 18:
      //18位身份号码检测
      //出生日期的合法性检查
      //闰年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))
      //平年月日:((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))
      var ereg;
      if (parseInt(idcard.substr(6, 4)) % 4 === 0 || (parseInt(idcard.substr(6, 4)) % 100 === 0 && parseInt(idcard.substr(6, 4)) % 4 === 0)) {
        ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/; //闰年出生日期的合法性正则表达式
      } else {
        ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/; //平年出生日期的合法性正则表达式
      }
      if (ereg.test(idcard)) {//测试出生日期的合法性
        //计算校验位
        S = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7
          + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9
          + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10
          + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5
          + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8
          + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4
          + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2
          + parseInt(idcard_array[7])
          + parseInt(idcard_array[8]) * 6
          + parseInt(idcard_array[9]) * 3;
        Y = S % 11;
        M = 'F';
        JYM = '10X98765432';
        M = JYM.substr(Y, 1);
        if (M == idcard_array[17].toUpperCase()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
      break;
    default:
      return false;
      break;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/common.js